module.exports = __webpack_public_path__ + "static/img/COC2023-2.9f20342.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-2.png
// module id = yrzY
// module chunks = 0